export enum TYPORGAPHY_CONSTANTS {
  TASK_STATUS = "Tasks Status",
  ADDING_A_TASK = "Adding a task",
  TASKS_MANAGEMENT = "Tasks Management",
  KANBAN_DESK = "Kandan Desk",
  ADD_A_NEW_TASK = "Adding a task",
  ADD_TASK = "Add task",
  TO_DO = "To Do"
}
